import { useLocale } from '../intl-custom'

export const useLanguage = () => {
  const locale = useLocale()
  return locale
}
